export enum FeedFilter {
  ALL = 'ALL',
  ORIGINAL = 'ORIGINAL',
  REPOST = 'REPOST'
}
